import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-user-profile-menu-item',
    templateUrl: './user-profile-menu-item.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiUserProfileMenuItemComponent {

    @HostBinding() class = 'eui-user-profile-menu-item';

    @Input() styleClass;

    constructor() {
    }
}
